import React from "react";
//
import Icon from "./Icon";

export default function Notifications({ unread, onPress }) {
  return (
    <a
      href="/chats"
      target="_blank"
      className="notifications"
      onClick={onPress}
    >
      <Icon name="notifications" small /> {unread}
    </a>
  );
}
